import { Component } from '@angular/core';
import { AuthCodeFormComponentUser } from '../utils/auth-code-form-user/auth-code-form-user.component';
import { ButtonModule } from 'primeng/button';
import { AppService } from '../services/app.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-unlink-device',
    imports: [AuthCodeFormComponentUser, ButtonModule],
    templateUrl: './unlink-device.component.html',
    styleUrl: './unlink-device.component.scss'
})
export class UnlinkDeviceComponent {
token: string = '';
  client!: number;
  enProceso = false;
  showSuccess = false;
  showResponse = false;
  showOtp = false;
  id:string='';
  data:string=''; 
   dataSend:string='';

  constructor(private services: AppService, private route: ActivatedRoute,) {
    this.route.queryParamMap.subscribe((params) => {
      this.token = params.get('token') || '';
      this.data= params.get('data') || '';
     
    });

  }

  ngAfterViewInit(): void {


  }

  sendUnlink(){
    this.enProceso = true
      var dcrypted= atob(this.data);
      console.log(dcrypted);
    var arrayInfo = dcrypted.trim().split('&');
    let isDriver = arrayInfo[1].replaceAll("isDriver=","");
     this.id= arrayInfo[2].replaceAll("id=","");
    this.data = arrayInfo[4].replaceAll("email=","");
    let usr = arrayInfo[5].replaceAll("user=","");
    this.client = parseInt(arrayInfo[3].replaceAll("client=",""));
    console.log(arrayInfo);
    this.dataSend = this.id+"_"+this.data+"_"+usr+"_"+isDriver;
    this.services.unlinkDeviceEmail(this.client, this.token, false,"",this.dataSend ,5).subscribe({
      next: (data: any) => {

        this.enProceso = false;
        if (data.isSuccess) {

          if (data.message.includes('Mensaje enviado')) {
            this.showOtp = true;
          } else {
            this.showSuccess = true;
            this.showResponse = true;
            this.showOtp = false;
          }


        }
      },
      error: (error: any) => {
        this.showResponse = true;
        this.enProceso = false;
        this.showSuccess = false;

      }
    })
  }

  closeForm(resp: any) {
    this.showOtp = false;
    this.showResponse = true;
    this.showSuccess = resp==undefined?false:resp.success;    
  }
}
